import type { ReconciliationLineDTO } from '../../services/reconciliation.service';

export interface ReconciliationLineTotals {
  amount: number;
  commission: number;
  taxAmount: number;
  totalCommission: number;
  lineTotal: number;
}

const EMPTY: ReconciliationLineTotals = {
  amount: 0,
  commission: 0,
  taxAmount: 0,
  totalCommission: 0,
  lineTotal: 0
};

export function sumReconciliationLineAmounts(
  lines: ReconciliationLineDTO[] | undefined | null
): ReconciliationLineTotals {
  if (!lines?.length) {
    return { ...EMPTY };
  }
  return lines.reduce<ReconciliationLineTotals>(
    (acc, l) => ({
      amount: acc.amount + (l.amount ?? 0),
      commission: acc.commission + (l.commission ?? 0),
      taxAmount: acc.taxAmount + (l.taxAmount ?? 0),
      totalCommission: acc.totalCommission + (l.totalCommission ?? 0),
      lineTotal: acc.lineTotal + (l.lineTotal ?? 0)
    }),
    { ...EMPTY }
  );
}
